import React from 'react';
import { Header, Item } from 'components/Navigation';
import { rm } from 'utils';
import { getQaDataAttr } from '@bygghemmait/utilities';
import { IMenuItem } from 'models/IMenuItem';

interface Ownprops {
  items: IMenuItem[];
}

const AdviceContact = ({ items }: Ownprops) => (
  <div>
    <Header invert>{rm('Advice_and_contact_title')}</Header>
    {items.map(item => {
      return (
        <Item key={item.id}>
          <Header>
            <a href={item.url} {...getQaDataAttr(`link-nav-${item.id}`)}>
              {item.title}
            </a>
          </Header>
        </Item>
      );
    })}
  </div>
);

export default AdviceContact;
